// Plausible Analytics custom events
// https://plausible.io/docs/custom-event-goals

declare global {
  interface Window {
    plausible?: (event: string, options?: { props?: Record<string, string | number | boolean> }) => void;
  }
}

export function trackEvent(
  event: string,
  props?: Record<string, string | number | boolean>
) {
  if (typeof window !== "undefined" && window.plausible) {
    window.plausible(event, { props });
  }
}

// Pre-defined events for consistency
export const analytics = {
  // Auth events
  registration: (method: string = "email") => trackEvent("Registration", { method }),
  login: () => trackEvent("Login"),
  logout: () => trackEvent("Logout"),

  // Subscription events
  subscriptionStarted: (plan: string) => trackEvent("Subscription Started", { plan }),
  subscriptionCanceled: (plan: string) => trackEvent("Subscription Canceled", { plan }),
  checkoutStarted: (plan: string) => trackEvent("Checkout Started", { plan }),

  // Domain events
  domainAdded: () => trackEvent("Domain Added"),
  domainVerified: () => trackEvent("Domain Verified"),

  // Tool usage
  toolUsed: (tool: string) => trackEvent("Tool Used", { tool }),
};
